import { render, staticRenderFns } from "./DropdownProfile.vue?vue&type=template&id=50a0897d&scoped=true&"
import script from "./DropdownProfile.vue?vue&type=script&lang=js&"
export * from "./DropdownProfile.vue?vue&type=script&lang=js&"
import style0 from "./DropdownProfile.vue?vue&type=style&index=0&id=50a0897d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50a0897d",
  null
  
)

export default component.exports